import Vue from 'vue';
import VueI18n from 'vue-i18n';
// Languages 

Vue.use(VueI18n);
const messages = {
  ar: {
    home: 'الرئيسية',
    verificationServices: 'خدمات التحقق',
    validation: {
      requiredField: 'الحقل مطلوب'
    },
    general: {
      mowakel: 'موكل',
      wakeel: 'وكيل',
      nationality: 'الجنسية',
      identityType: 'نوع الهوية',
      identityNumber: 'رقم الهوية',
      tarafStatusInWakala: 'حالته بالوكالة',
      backToVerificationServices: 'العودة لخدمات التحقق',
      together: 'مجتمعين',
      notTogether: 'غير مجتمعين',
      valid: 'سارية',
      inValid: 'غير سارية',
      downloadWekalaDoc: 'تحميل وثيقة الوكالة',
      downloadExternalWekalaDoc: 'تحميل وثيقة الوكالة الخارجية',
      sefaName: 'الصفة',
      noExternalWekalaNumber: 'لا يوجد',
      copiedSuccess: 'تم النسخ بنجاح'
    },
    Qaim: {
      FooterText: 'الخدمات الإلكترونية لوزارة العدل',
      HeaderText: 'الخدمات الإلكترونية لوزارة العدل',
      VerificationHeaderText: 'تم التحقق من الوكالة بنجاح',
    },
    wekalaVerification: {
      pageTitle: 'التحقق من وكالة',
      wakalaInfo: 'بيانات الوكالة',
      cancelNote: 'ملاحظات',
      externalTasdekwakalaInfo: 'بيانات تصديق الوكالة الخارجية',
      wakalaNumber: 'رقم الوكالة',
      tasdekNumber: 'رقم التصديق',
      wakalaNumberPlaceHolder: 'أدخل رقم الوكالة / رقم تصديق الوكالة الخارجية',
      wakalaStatus: 'حالة الوكالة',
      wakalaIssuePlace: 'جهة الإصدار',
      issuerTasdek: 'جهة تصديق الوكالة',
      wakalaIsTogether: 'كيفية الاستخدام',
      wakalaIssueDate: 'تاريخ إصدار الوكالة',
      wakalaExpireDate: 'تاريخ إنتهاء الوكالة',
      issueDateTasdek: 'تاريخ إصدار التصديق',
      endDateTasdek: 'تاريخ إنتهاء التصديق',
      wakalaPartiesInfo: 'بيانات أطراف الوكالة',
      wakalaClausesInfo: 'بنود الوكالة',
      wakalaText: 'نص الوكالة',
      description: 'خدمة تتيح للمستفيد التحقق من حالة الوكالة الصادرة من وزارة العدل او الوكالة الخارجية المصادق عليها إلكترونياً، بالإضافة الى إمكانية مشاهدة بنود و نص الوكالة،و تحميل الوكالة إلكترونياً.',
      identityNumber: 'رقم هوية أحد أطراف الوكالة',
      identityNumberPlaceHolder: 'أدخل رقم هوية أحد أطراف الوكالة',
      verifierIdentityNumber: 'رقم هوية المتحقق',
      verifierIdentityNumberPlaceHolder: 'أدخل رقم هوية المتحقق (هوية وطنية / إقامة)',
      verify: 'تحقق',
      newVerification: 'تحقق جديد',
      externalWekalaNumber: 'رقم الوكالة الخارجية',
      externalWekalaSource: 'مصدر الوكالة الخارجية',
      externalIssueDate: 'تاريخ إصدار الوكالة الخارجية',
      externalExpiryDate: 'تاريخ انتهاء الوكالة الخارجية',
      externalTasdekKharijyaDate:
        'تاريخ تصديق وزارة الخارجية للدولة المصدرة للوكالة',
      externaEmbasadyDate: 'تاريخ تصديق السفارة أو القنصلية السعودية',
      externalTasdekMofaKharijyaDate: 'تاريخ تصديق وزارة الخارجية السعودية',
      externalWekalaCountry: 'الدولة المصدرة'

    },
    anonymousUserVerification: {
      dialogs: {
        verfiyAnonymousUserDialog: 'التحقق من الهوية',
        idNumber: 'رقم الهوية',
        dateOfBirth: 'تاريخ الميلاد',
        verify: 'تحقق',
        back: 'إلغاء',
        otpCode: 'رمز التحقق',
        resend: 'إعادة إرسال',
        alertText: 'الوقت المتبقي لانتهاء المدة المسموحة:',
        otpPlaceHolder: 'الرجاء إدخال رمز التحقق المرسل إلى جوالك المسجل في أبشر',
        nafathPlaceHolder: 'الرجاء فتح تطبيق نفاذ واختيار الرقم الظاهر في الشاشة',
        nafathheaderTitle: 'تأكيد رمز التحقق ',
        nafathGeneralError: 'حدث خطأ فني أثناء تنفيذ العملية يرجى المحاولة مرة أخرى'
      },
    },
  }
};

const i18n = new VueI18n({
  locale: 'ar', // set locale
  messages, // set locale messages
});

export default i18n;
